import { obisCodeCfgUnits } from '../../../../obis-code/ObisCodeCfgUnits';
import { cfgUnits } from '../../../../obis-code/CfgUnits';
import { UplotSeriesConfig } from '../models/UplotSeriesConfig.model';

export function getBaseUnitForScale(unit: string): string {
  // obisCodeCfgUnits
  const obisGroup = obisCodeCfgUnits.find((o) => o.units.includes(unit));
  if (obisGroup && obisGroup.baseUnit) return unit;
  return 'y';
}

export function getAllBaseUnitsForSeries(series: UplotSeriesConfig[] = null) {
  const allUnits = Array.from(cfgUnits.values()).map((o) => getBaseUnitForScale(o.unit));
  const additionalUnits = ['None'];
  const excludeUnits = ['y'];

  return [...allUnits, ...additionalUnits]
    .filter((o, i, s) => s.findIndex((fi) => fi == o) == i)
    .filter((o) => {
      if (!series) return true;
      else return series.map((s: any) => s.scale).includes(o);
    })
    .filter((o) => !excludeUnits.includes(o));
}
